<div class="-oneX-container">
  <div class="-oneX-heading--h2">Claim Handler</div>
  <br>
  <div class="-oneX-row -oneX-justify-content-center">
    <div class="-oneX-col-10">
      <table class="-oneX-table--standard" aria-label="Standard table">
        <thead class="-oneX-thead">
          <tr class="-oneX-tr">
            <th class="-oneX-th--col">Type</th>
            <th class="-oneX-th--col">Name</th>
            <th class="-oneX-th--col">Phone</th>
            <th class="-oneX-th--col">Fax</th>
            <th class="-oneX-th--col">Mailing Address </th>
            <th class="-oneX-th--col">Email</th>
          </tr>
        </thead>
        <tbody class="-oneX-tbody">
          <tr class="-oneX-tr" *ngFor="let handler of handlersArray; let i=index ;">
            <td class="-oneX-td">{{handlersArray[i].subType}}</td>
            <td class="-oneX-td" id="name1">{{handlersArray[i].name}}</td>
            <td class="-oneX-td" id="phone1">{{handlersArray[i].phone}}</td>
            <td class="-oneX-td" id="fax1">{{handlersArray[i].fax}}</td>
            <td class="-oneX-td" id="mail1">{{handlersArray[i].address}}</td>
            <td class="-oneX-td" id="email1">{{handlersArray[i].email}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>